import './AppBanner.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

/* eslint-disable react/prop-types */
export default function AppBanner({ text, closeText, onClose }) {
  return (
    <div className="app-banner">
      <p className="banner-text">{text}</p>
      <button
        type="button"
        className={`close-button ${closeText ? 'text-button' : 'x-button'}`}
        onClick={onClose}
      >
        {closeText ?? <FontAwesomeIcon className="icon" icon={faXmark} />}
      </button>
    </div>
  );
}
